<template>
  <div>
    <cardType></cardType>
    <cardItem></cardItem>
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
</style>